import { Link } from "react-router-dom";

const services = [
  {
    title: "Sliding Door Repair",
    desc: "Roller, track, and lock repair for patio and sliding glass doors.",
    path: "/sliding-door-repair/",
  },
  {
    title: "Glass Replacement",
    desc: "Non-impact glass replaced in existing residential frames.",
    path: "/glass-replacement/",
  },
  {
    title: "Window Hardware Repair",
    desc: "Locks, latches, balances, hinges, and crank operators.",
    path: "/window-hardware-repair/",
  },
  {
    title: "Weatherstripping & Sealing",
    desc: "Air and water leak sealing with marine-grade weatherstripping.",
    path: "/weatherstripping-sealing/",
  },
  {
    title: "Window Cleaning & Maintenance",
    desc: "Interior and exterior cleaning plus track and hardware lubrication.",
    path: "/window-cleaning-maintenance/",
  },
  {
    title: "Emergency Board-Up",
    desc: "Temporary plywood protection after storm damage or break-in.",
    path: "/emergency-board-up/",
  },
];

interface RepairServicesGridProps {
  heading?: string;
}

export default function RepairServicesGrid({ heading }: RepairServicesGridProps) {
  return (
    <section className="w-full bg-white py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-roboto font-bold text-2xl md:text-[32px] text-[#064e3b] mb-3">
            {heading || "Repair Services We Offer"}
          </h2>
          <p className="text-gray-600 text-base max-w-[720px] mx-auto">
            Hardware repair, glass replacement, and maintenance. We do not install new windows.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s) => (
            <Link
              key={s.path}
              to={s.path}
              className="block bg-white border border-gray-200 rounded-xl p-6 hover:border-[#047857] hover:shadow-sm transition-all group"
            >
              <h3 className="font-bold text-base text-[#064e3b] mb-2 group-hover:text-[#047857] transition-colors">
                {s.title}
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed">{s.desc}</p>
              <div className="mt-4 inline-flex items-center gap-1 text-[#047857] text-sm font-bold group-hover:text-[#ea580c] transition-colors">
                {s.title} in Miami
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}